<template>
  <com-page>
    <com-search :columns="searchColumn" @search="handleSearch">
      <template>
        <el-button type="primary" @click="handleCreated">添加套餐卡</el-button>
      </template>
    </com-search>
    <com-card>
      <PackageCard ref="PackageCardRef"></PackageCard>
    </com-card>
  </com-page>
</template>

<script>
import PackageCard from './components/package-card-list'

export default {
  components: { PackageCard },
  data() {
    return {
      searchColumn: [
        {
          label: '套餐卡名称',
          prop: 'name',
          type: 'input'
        }
      ],
      exportQuery: {
        pageIndex: 1,
        pageSize: 10000
      }
    }
  },
  methods: {
    handleCreated() {
      this.$router.push({ name: 'package-card-edit', params: { type: 'created' } })
    },
    handleSearch(val) {
      const params = {
        ...val
      }
      this.exportQuery = { pageIndex: 1, pageSize: 10000, ...params }
      this.$refs.PackageCardRef.search(params)
      console.log('search :>> ', params)
    }
  },
  activated() {
    console.log('activated :>> ,', this.$route)
    if (this.$route.params) {
      const { type } = this.$route.params
      if (type === 'update') this.$refs.PackageCardRef.init()
    }
    // this.$refs.PackageCardRef.init()
  }
}
</script>
